export const themes = {
  light: {
    background: {
      body: "#EFF2F5",
      primary: "#fff",
      header: "rgba(255, 255, 255, 0.9)",
      searchBox: "#cfe0f1",
      opacity: "rgba(255, 255, 255, 0.3)",
      popup: "#D4D4D4",
      toolbar: "#F5F5F5",
      toolbarOff: "#BABABA"
    },
    primary: "#0051c3",
    text: {
      primary: "#303030",
      second: "#505050",
      third: "#888",
      searchBox: "#0051c3",
      negative: "#fff",
      remind: "#888",
    },
    boxShadow: {
      primary: "0 0 30px rgba(33, 83, 154, 0.08)",
      second:
        "0 0 30px rgba(33, 83, 154, 0.08), inset 1px 1px 5px rgba(255, 255, 255, 0.3)",
      float: "0px 5px 5px -5px rgba(0, 0, 0, 0.3)"
    },
    button: {
      menu: "#fff",
      submit: "#303030",
      modify: "#0051c3",
      label: "#e5be90",
      google: " #4285f4"
    },
    loading: {
      border: "rgba(0, 81, 195, 0.3)",
      focus: "#0051c3",
    },
    toggler: {
      fill: "rgba(0, 0, 0, 0.5)",
      right: "100%",
      translate: "(105%, 5%)"
    },
    error: "#cb0000",
  },
  dark: {
    background: {
      body: "#293136",
      primary: "#313B41",
      header: "rgba(207, 224, 241, 0.08)",
      searchBox: "#9cbfe2",
      opacity: "rgba(207, 224, 241, 0.02)",
      popup: "#6E6E6E",
      toolbar: "#404040",
      toolbarOff: "#BABABA"
    },
    primary: "#82B1FF",
    text: {
      primary: "#F2F2F2",
      second: "#CCC",
      third: "#6d6d6d",
      searchBox: "#293136",
      negative: "#313B41",
      remind: "#aaa",
    },
    boxShadow: {
      primary: "0 0 30px rgba(0, 0, 0, 0.1)",
      second:
        "0 0 10px rgba(0, 0, 0, 0.1), inset 1px 1px 5px rgba(255, 255, 255, 0.03)",
      float: "0px 5px 5px -5px rgba(255, 255, 255, 0.3)"
    },
    button: {
      menu: "#fff",
      submit: "#CFE0F1",
      modify: "#999",
      label: "#FF6363",
      google: " #4285f4"
    },
    loading: {
      border: "rgba(255, 255, 255, 0.2)",
      focus: "#fff",
    },
    toggler: {
      fill: "rgb(245, 222, 73)",
      right: "0",
      translate: "(-5%, 5%)"
    },
    error: "#D04D5A",
  },
};

export default themes;